import { Button, Space, Table, notification } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { useApproveBidderMutation, useRejectBidderMutation } from '../../../app/api/userApiSlice';
import AuctionRequest from '../../../core/models/AuctionRequest';

interface IProps {
  isLoading: boolean;
  bidders: AuctionRequest[] | undefined;
}

const BidderTable: React.FC<IProps> = ({ isLoading, bidders }) => {
  const [approveBidder, { isLoading: loadingApproveBidder }] = useApproveBidderMutation();
  const [rejectBidder, { isLoading: loadingRejectBidder }] = useRejectBidderMutation();

  const handleApprove = (bidderId: string): void => {
    void (async () => {
      try {
        await approveBidder({ id: bidderId });
        notification.success({
          message: 'Success',
          description: 'Request approved successfully',
        });
      } catch (error) {
        console.log(error)
      }
    })();
  };

  const handleReject = (bidderId: string): void => {
    void (async () => {
      try {
        await rejectBidder({ id: bidderId });
        notification.success({
          message: 'Success',
          description: 'Request rejected',
        });
      } catch (error) {
        console.log(error)
      }
    })();
  };

  const columns: ColumnsType<AuctionRequest> = [
    {
      title: 'Name',
      dataIndex: ['buyer', 'name'],
      key: 'name',
      render: (name, record) => <Link to={`/users/buyers/${record.buyer.id}`}>{name}</Link>,
    },
    {
      title: 'Auction',
      dataIndex: ['auction', 'title'],
      key: 'name',
      render: (title, record) => <Link to={`/auctions/${record.auction.id}`}>{title}</Link>,
    },
    {
      title: 'Auction Date',
      dataIndex: ['auction', 'auctionDate'],
      key: 'name',
      render: (date, record) => <p>{moment(date).format('DD/MM/YYYY HH:mm A')}</p>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Button
            type='link'
            onClick={() => handleApprove(record.id)}
            loading={loadingApproveBidder}
          >
            Approve
          </Button>
          <Button
            type='link'
            danger
            onClick={() => handleReject(record.id)}
            loading={loadingRejectBidder}
          >
            Reject
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Table dataSource={bidders} columns={columns} rowKey='id' loading={isLoading} size='small' />
  );
};

export default BidderTable;
